

const TopMotivos = ({ motivos }) => {
  const top5 = motivos.slice(0, 5); // Solo mostrar los 5 primeros

  return (
    <div className="mb-3 d-flex justify-content-center">
      <div className="card shadow-lg border-0 rounded-3" style={{ width: "100%", maxWidth: "400px" }}>
        <div
          style={{
            background: "linear-gradient(90deg, #4e73df, #1cc88a)",
            padding: "10px 15px",
            borderTopLeftRadius: "0.5rem",
            borderTopRightRadius: "0.5rem",
          }}
        >
          <h6 className="mb-0 text-center fw-bold text-white">Top 5 Motivos</h6>
        </div>

        <ul className="list-group list-group-flush">
          {top5.map((m, idx) => (
            <li
              key={idx}
              className="list-group-item d-flex justify-content-between align-items-center"
              style={{ fontSize: "0.95rem", transition: "background 0.3s" }}
              onMouseEnter={(e) => (e.currentTarget.style.background = "#f8f9fc")}
              onMouseLeave={(e) => (e.currentTarget.style.background = "white")}
            >
              <span className="fw-semibold">
                {idx + 1}. {m.motivo}
              </span>
              <span className="badge bg-primary rounded-pill px-3 py-2">
                {m.cantidad}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default TopMotivos;
